import axios, { AxiosInstance, AxiosResponse, RawAxiosRequestHeaders } from 'axios'
import { axiosResponseErrorInterceptor, getHeaders } from '../axios-helper'

export function getShippingServiceInstance(): AxiosInstance {
  const instance: AxiosInstance = axios.create({
    baseURL: `${window.location.protocol}//${import.meta.env.VITE_BASE_URL}`,
    headers: getHeaders() as RawAxiosRequestHeaders,
  })
  instance.interceptors.response.use(
    (response: AxiosResponse) => response,
    axiosResponseErrorInterceptor,
  )
  return instance
}
